<template>
    <div class="app-navbar-wrapper">
        <!-- Mobile -->
        <el-drawer v-if="app.device === 'mobile'" title="我是标题" :visible.sync="isCollapse" :direction="'ltr'"
            :before-close="beforeCloseDrawer" :wrapperClosable="true" size="210px" :with-header="false">
            <el-scrollbar wrap-class="scrollbar-wrapper">
                <el-menu :default-active="activePath" :default-openeds="defaultOpeneds" :unique-opened="uniqueOpened"
                    ref="menusRef">
                    <div v-for="(menu, index) in menus" :key="index">
                        <!-- 一级菜单,有子菜单 -->
                        <template v-if="menu.childrenNode && menu.childrenNode.length">
                            <el-submenu :index="`${index}`">
                                <template #title>
                                    <i class="rhcn-menu-icon iconfont" :class="getMenuIcon(menu)"></i>
                                    <span class="rhcn-menu-title">{{ menu.name }}</span>
                                </template>
                                <div v-for="(submenu, index1) in menu.childrenNode" :key="index1">
                                    <!-- 存在三级菜单 -->
                                    <!-- {{  submenu.childrenNode}} -->
                                    <template
                                        v-if="submenu.childrenNode && submenu.childrenNode.length && submenu.childrenNode[0].resourceType === 1 && app.userLogin.isAggregateMerchant">
                                        <el-submenu :index="`${index}-${index1}`">
                                            <template #title>
                                                <i class="rhcn-menu-icon iconfont" :class="getMenuIcon(submenu)"></i>
                                                <span class="rhcn-menu-title">{{ submenu.name }}</span>
                                            </template>
                                            <div v-for="(submenu1, index2) in submenu.childrenNode" :key="index2">
                                                <template v-if="submenu1.menuUrl">
                                                    <router-link :to="submenu1.menuUrl">
                                                        <el-menu-item :index="`${submenu1.menuUrl}`">
                                                            <span class="rhcn-menu-title">
                                                                {{ submenu1.name }}</span>
                                                        </el-menu-item>
                                                    </router-link>
                                                </template>
                                                <template v-else>
                                                    <el-menu-item :index="`${submenu1.menuUrl}`">
                                                        <span class="rhcn-menu-title">
                                                            {{ submenu1.name }}
                                                        </span>
                                                    </el-menu-item>
                                                </template>
                                            </div>
                                        </el-submenu>
                                    </template>
                                    <!-- 不存在三级菜单 -->
                                    <template v-else>
                                        <template v-if="submenu.menuUrl">
                                            <router-link :to="submenu.menuUrl">
                                                <el-menu-item :index="`${submenu.menuUrl}`"><span
                                                        class="rhcn-menu-title">{{
                                                            submenu.name
                                                        }}</span></el-menu-item>
                                            </router-link>
                                        </template>
                                        <template v-else>
                                            <el-menu-item :index="`${submenu.menuUrl}`"><span class="rhcn-menu-title">{{
                                                submenu.name
                                                    }}</span></el-menu-item>
                                        </template>
                                    </template>
                                </div>
                            </el-submenu>
                        </template>
                        <!-- 一级菜单,没有子菜单 -->
                        <template v-if="!menu.childrenNode || !menu.childrenNode.length">
                            <router-link v-if="menu.menuUrl" :to="menu.menuUrl">
                                <el-menu-item :index="`${menu.menuUrl}`">
                                    <i class="rhcn-menu-icon iconfont" :class="getMenuIcon(menu)"></i>
                                    <template #title><span class="rhcn-menu-title">{{
                                        menu.name
                                            }}</span></template>
                                </el-menu-item>
                            </router-link>
                            <template v-else>
                                <el-menu-item :index="`${menu.menuUrl}`">
                                    <i class="rhcn-menu-icon iconfont" :class="getMenuIcon(menu)"></i>
                                    <template #title><span class="rhcn-menu-title">{{
                                        menu.name
                                            }}</span></template>
                                </el-menu-item>
                            </template>
                        </template>
                    </div>
                </el-menu>
            </el-scrollbar>
        </el-drawer>
        <!-- PC -->
        <el-aside class="aside-wrapper" v-if="app.device !== 'mobile'" width="238px">
            <el-scrollbar wrap-class="scrollbar-wrapper">
                <div class="logo-wrapper">
                    <img v-if="!isCollapse" class="logo" src="../../../../assets/images/login-logo1.png"
                        style="width: 156px" />
                    <img class="icon"
                        :src="isCollapse ? require('../../../../assets/images/icon-menu-close.png') : require('../../../../assets/images/icon-menu-open.png')"
                        style="width: 27px" @click="toggleMenu" />
                </div>
                <div v-if="!app.userLogin.isManage && !isCollapse" class="margin-top-10 margin-bottom-20">
                    <MerchantSwitch></MerchantSwitch>
                </div>
                <!-- <div v-if="showTransferButton" class="btn-transfer-wrapper">
            <el-button class="btn-transfer" type="primary" @click="handleTransfer">{{$t('message.transfer.transferMoney')}}</el-button>
          </div> -->
                <el-menu :default-active="activePath" :default-openeds="defaultOpeneds" :unique-opened="uniqueOpened"
                    :collapse="isCollapse" :collapse-transition="false" @open="handleSelect" ref="menusRef">
                    <div v-for="(menu, index) in menus" :key="index">
                        <!-- 一级菜单,有子菜单 -->
                        <template v-if="menu.childrenNode && menu.childrenNode.length">
                            <el-submenu :index="`${index}`">
                                <template #title>
                                    <i class="rhcn-menu-icon iconfont" :class="getMenuIcon(menu)"></i>
                                    <span class="rhcn-menu-title">{{ menu.name }}</span>
                                </template>
                                <div v-for="(submenu, index1) in menu.childrenNode" :key="index1">
                                    <!-- 存在三级菜单 -->
                                    <!-- {{  submenu.childrenNode}} -->
                                    <template
                                        v-if="submenu.childrenNode && submenu.childrenNode.length && submenu.childrenNode[0].resourceType === 1 && app.userLogin.isAggregateMerchant">
                                        <el-submenu :index="`${index}-${index1}`">
                                            <template #title>
                                                <i class="rhcn-menu-icon iconfont" :class="getMenuIcon(submenu)"></i>
                                                <span class="rhcn-menu-title">{{ submenu.name }}</span>
                                            </template>
                                            <div v-for="(submenu1, index2) in submenu.childrenNode" :key="index2">
                                                <template v-if="submenu1.menuUrl">
                                                    <router-link :to="submenu1.menuUrl">
                                                        <el-menu-item :index="`${submenu1.menuUrl}`">
                                                            <span class="rhcn-menu-title">
                                                                {{ submenu1.name }}</span>
                                                        </el-menu-item>
                                                    </router-link>
                                                </template>
                                                <template v-else>
                                                    <el-menu-item :index="`${submenu1.menuUrl}`">
                                                        <span class="rhcn-menu-title">
                                                            {{ submenu1.name }}
                                                        </span>
                                                    </el-menu-item>
                                                </template>
                                            </div>
                                        </el-submenu>
                                    </template>
                                    <!-- 不存在三级菜单 -->
                                    <template v-else>
                                        <template v-if="submenu.menuUrl">
                                            <router-link :to="submenu.menuUrl">
                                                <el-menu-item :index="`${submenu.menuUrl}`"><span
                                                        class="rhcn-menu-title">{{
                                                            submenu.name
                                                        }}</span></el-menu-item>
                                            </router-link>
                                        </template>
                                        <template v-else>
                                            <el-menu-item :index="`${submenu.menuUrl}`"><span class="rhcn-menu-title">{{
                                                submenu.name
                                                    }}</span></el-menu-item>
                                        </template>
                                    </template>
                                </div>
                            </el-submenu>
                        </template>
                        <!-- 一级菜单,没有子菜单 -->
                        <template v-if="!menu.childrenNode || !menu.childrenNode.length">
                            <router-link v-if="menu.menuUrl" :to="menu.menuUrl">
                                <el-menu-item :index="`${menu.menuUrl}`">
                                    <i class="rhcn-menu-icon iconfont" :class="getMenuIcon(menu)"></i>
                                    <template #title><span class="rhcn-menu-title">{{
                                        menu.name
                                            }}</span></template>
                                </el-menu-item>
                            </router-link>
                            <template v-else>
                                <el-menu-item :index="`${menu.menuUrl}`">
                                    <i class="rhcn-menu-icon iconfont" :class="getMenuIcon(menu)"></i>
                                    <template #title><span class="rhcn-menu-title">{{
                                        menu.name
                                            }}</span></template>
                                </el-menu-item>
                            </template>
                        </template>
                    </div>
                </el-menu>
            </el-scrollbar>
        </el-aside>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { listMenuButtons } from '@/api/common/user';
import MerchantSwitch from '@/layout/base/components/iswitch/index.vue';

export default {
    name: 'INavbar',
    components: {
        MerchantSwitch,
    },
    props: {
        isCollapse: {
            type: Boolean,
            default: false,
            homeroutes: [],
        },
        uniqueOpened: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapGetters([
            'app',
            'permission',
        ]),
    },
    data() {
        return {
            menus: [],
            defaultOpeneds: [],
            activePath: this.$route.path,
            showTransferButton: false,
            isCheckedTransfer: false,
        };
    },
    created() {
        // console.log('app', this.app.userLogin);
        this.menus = JSON.parse(JSON.stringify(this.permission.menus)); // 深拷贝，防止污染原数据
        this.menus = this.menus.map(item => {
            if (item.childrenNode && item.childrenNode.length) {
                // 保留页面
                item.childrenNode = item.childrenNode.filter(item => (+item.resourceType === 1));
            }
            // 特殊处理钱包页面标题  收单商户&&英文
            if (item.resourceCode === 'transfer' && this.$store.getters.app.currentLan === 'en' && this.app.userLogin.businessType === '1') {
                item.name = 'Withdraw';
                item.childrenNode[0].name = 'Withdraw';
                item.childrenNode[1].name = 'Beneficiaries';
            }
            return item;
        });

        for (let i = 0; i < this.menus.length; i++) {
            if (this.$route.path.indexOf(this.menus[i].resourceCode) === 1) {
                this.defaultOpeneds.push(`${i}`);
            }
        }

        // console.log('this.menus---', this.menus);

        // 登录成功后页面路由配置
        const routes = this.$router.options.routes;
        console.log('routes', routes);
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].path === '/') {
                this.homeroutes = routes[i];
                break;
            }
        }
        if (this.$route.meta.activeMenu) {
            this.activePath = this.$route.meta.activeMenu;
        }

        // this.checkTransferAuth();
    },
    methods: {
        toggleMenu() {
            if (this.isCollapse) {
                this.$emit('closeNavbar');
            } else {
                this.$emit('openNavbar');
            }
        },
        beforeCloseDrawer() {
            this.$emit('closeNavbar');
        },
        closeDrawer() {
            console.log(1);
        },
        getMenuIcon(menu) {
            for (let i = 0; i < this.homeroutes.children.length; i++) {
                const route = this.homeroutes.children[i];
                if (route.meta && route.meta.resourceCode) {
                    const resourceOne = route.meta.resourceCode.split(':')[0];
                    if (resourceOne === menu.resourceCode) {
                        return route.meta.icon;
                    }
                }
            }
            return 'icon-home1';
        },
        handleTransfer() {
            this.$router.push({ path: '/transfer/transfer/add/recipient' });
        },
        async checkTransferAuth() {
            // 商户业务类型为 B2B/B2C 时显示按钮
            const userLogin = this.app.userLogin;
            if (userLogin && `${userLogin.businessType}` !== '0' && `${userLogin.businessType}` !== '2') {
                this.isCheckedTransfer = true;
                this.showTransferButton = false;
                return;
            }
            if (this.isCheckedTransfer) { // 已经检测过权限后，不再继续检测
                return;
            }
            try {
                for (let i = 0; i < this.menus.length; i++) {
                    const menu = this.menus[i];
                    if (menu.resourceCode === 'transfer') {
                        const subMenuList = menu.childrenNode || [];
                        for (let j = 0; j < subMenuList.length; j++) {
                            const subMenu = subMenuList[j];
                            if (subMenu.resourceCode === 'transfer:transfer') {
                                const pList = await listMenuButtons(subMenu.id);
                                if (pList.includes('transfer:transfer:add')) {
                                    this.showTransferButton = true;
                                }
                                break;
                            }
                        }
                        break;
                    }
                }
                // 已完成检测
                this.isCheckedTransfer = true;
            } catch (err) {
                //
            }
        },
        handleSelect(index) {
            // console.log('index', index);
            // console.log('menuDefault', menuDefault);
            const menu = this.menus[index];
            console.log('menu', menu);
            if (menu.resourceCode === 'myself') {
                console.log('menu.childrenNode[0].childrenNode[0].menuUrl', menu.childrenNode[0].childrenNode[0].menuUrl);
                this.$router.push({ path: menu.childrenNode[0].childrenNode[0].menuUrl });
                return;
            }
            // console.log('即将导航到的菜单属于:', this.menus[index]);
            if (menu && menu.childrenNode && menu.childrenNode.length > 0) {
                this.$router.push({ path: menu.childrenNode[0].menuUrl });
            }
        },
        selectMenu(index, menuDefault) {
            // console.log('index', index);
            // console.log('menuDefault', menuDefault);
            // const menu = this.menus[menuDefault[0]];
            // console.log('即将导航到的菜单属于:', menu, menu.resourceCode);
            // if (menu.resourceCode === 'bigPayout') {
            //     console.log('进入引导页');
            //     this.$router.push({ path: '/guide' });
            // }
        },
    },
    watch: {
        $route: {
            handler(newValue) {
                // console.log('newValue', newValue);
                if (newValue.meta.activeMenu) {
                    this.activePath = newValue.meta.activeMenu;
                } else {
                    this.activePath = newValue.path;
                }

                for (let i = 0; i < this.menus.length; i++) {
                    if (this.activePath.indexOf(this.menus[i].resourceCode) === 1) {
                        if (!this.menus[i].childrenNode || this.menus[i].childrenNode.length === 0) {
                            this.defaultOpeneds = []; // 当前菜单为一级菜单时，清空打开的菜单
                        }
                    }
                }
            },
        },
    },
};
</script>
<style lang="scss">
.app-navbar-wrapper .el-scrollbar {
    height: 100%;

    .el-submenu__icon-arrow.el-icon-arrow-down {
        display: none;
    }
}
</style>
<style lang="scss" scoped>
.btn-transfer-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    margin-top: 10px;

    .btn-transfer {
        height: 40px;
        font-size: 14px;
        font-family: Avenir-Heavy, Avenir;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 36px;
        width: 132px;
    }
}
</style>
